
export default {
  state: {
    data: {
      metaError: 'Não foi possível carregar a meta API',
    }
  },
  mutations: {
    updateMeta (state, metaData) {
      state.data = metaData
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/meta.js